import React, { forwardRef } from "react";
import { SlidersHorizontal } from "lucide-react";

/**
 * The Filters trigger.
 *
 * When filters are on, the label collapses from "Filters" to the bare count
 * rather than growing a badge — the dock header is 384px wide and the button
 * shares its row with a three-segment control, so the active state has to be
 * narrower than the resting one, not wider.
 *
 * @param {Object} props
 * @param {() => void} props.onClick
 * @param {number} props.activeCount - 0 renders the resting state.
 * @param {boolean} [props.expanded] - Drives aria-expanded.
 */
export const FiltersButton = forwardRef(function FiltersButton(
  { onClick, activeCount = 0, expanded = false },
  ref
) {
  const active = activeCount > 0;

  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      aria-expanded={expanded}
      aria-haspopup="dialog"
      aria-label={active ? `Filters, ${activeCount} active` : "Filters"}
      className={`inline-flex flex-shrink-0 items-center gap-1.5 rounded-full border px-[11px] py-[7px] text-xs transition-colors ${
        active
          ? "border-orange-primary bg-light-orange font-bold text-bc-accent-text"
          : "border-gray-200 bg-white font-semibold text-gray-700 hover:border-gray-300 hover:bg-[#FBFBFB]"
      }`}
    >
      <SlidersHorizontal aria-hidden="true" className="h-3.5 w-3.5" />
      <span>{active ? activeCount : "Filters"}</span>
    </button>
  );
});

export default FiltersButton;
